module.exports = __webpack_public_path__ + "static/img/P6.52a8c1a3.png";